<script>
  import Headline from './PortfolioHealine.svelte'
  import Gallery from './PortfolioGallery.svelte'
</script>

<div class="mb-[128px] mt-[122px]">
  <Headline />
  <Gallery />
</div>
